import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'issueHeaderIcon',
    standalone: false,
    pure: true
})
export class IssueHeaderIconPipe implements PipeTransform {
  private readonly icons: Record<string, string> = {
    'low': 'assets/img/low_priority.svg',
    'normal': 'assets/img/normal_priority.svg',
    'high': 'assets/img/high_priority.svg',
    'emergency': 'assets/img/emergency_priority.svg'
  };

  transform(urgency: string): string {
    if (!urgency) {return '';}
    return this.icons[urgency] || '';
  }
}
